import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const RevenueChart = ({ title, graphData }) => {

    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();

    const filteredData = graphData.filter(entry => {
        const entryDate = new Date(entry.date);
        return entryDate.getMonth() + 1 === currentMonth && entryDate.getFullYear() === currentYear;
    });

    return (
        <div className='column'>
            <h4>{title}</h4>
            <ResponsiveContainer width="100%" height={250}>
                <AreaChart data={filteredData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        tick={{ fontSize: 10 }}
                        dataKey="date"
                        tickFormatter={(date) => new Date(date).getDate()}
                    />
                    <YAxis tick={{ fontSize: 10 }} />
                    <Tooltip />
                    <Area
                        type="monotone"
                        dataKey="revenue"
                        stroke="#82ca9d"
                        fill="#82ca9d"
                        strokeWidth={2}
                        fillOpacity={0.3}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
};

export default RevenueChart;
